export default __webpack_public_path__ + "static/media/popover-usage.be877455.svg";